export default __webpack_public_path__ + "static/media/mtTemplate.d15e7c60.csv";